import HostFreeAreaService from '@/services/free-area/host-free-area'

export class PointFreeAreaService extends HostFreeAreaService {
  protected get freeAreaPaths(): string[] {
    return [
      'PointListHeaderFreeArea',
      'PointListFooterFreeArea',
    ]
  }
}
